// extracted by mini-css-extract-plugin
export default {"container":"JS-z","topReviewHeading":"KS-z","criticalReview":"LS-z","favorableReview":"MS-z","vsSeparator":"NS-z"};